/*
 * @Description:
 * @Author: Rfan
 * @Date: 2021-10-18 16:36:26
 * @LastEditTime: 2024-08-22 10:29:41
 */
const getters = {
  getParams: (state) => {
    let params = Object.create(null);
    params.cur_user_id = state.user.id || -1;
    params.userId = state.user.id || -1;
    params.token = state.token;
    return () => Object.assign({}, params);
  },

  getQuery: (state) => state.query,

  getImgBaseUrl: (state) => state.imgBaseUrl,

  getTransferUser: (state) => state.transferUser,

  getSafeTransfer: (state) => state.safeTransfer,

  getUserAvatar: (state) => state.user.avatar,

  getUserNick: (state) => state.user.nick,

  getVersion: (state) => state.version,

  vote_selectList: (state) => state.vote.selectWorks,
  
  getGiftList: state => state.settings.giftList,

  getGiftOrderedList: state => state.settings.giftOrderedList,
  
  getMedalListList: state => state.settings.medalList,
  
  getMemberInfo: state => state.user,

  vote_isSelected: (state) => (id) => {
    const selectSet = new Set(state.vote.selectWorks);
    return selectSet.has(id);
  },

  vote_selectOrder: (state) => (id) => {
    return state.vote.selectWorks.indexOf(id) >= 0
      ? state.vote.selectWorks.indexOf(id) + 1
      : "";
  },
};
export default getters;
